var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.56 0H5.52C2.47139 0 0 2.47139 0 5.52V16.56C0 19.6086 2.47139 22.08 5.52 22.08H16.56C19.6086 22.08 22.08 19.6086 22.08 16.56V5.52C22.08 2.47139 19.6086 0 16.56 0Z",
    fill: "#FF3833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3132 10.4063C15.4465 11.3051 15.293 12.2231 14.8745 13.0296C14.456 13.8362 13.7938 14.4902 12.9822 14.8987C12.1706 15.3073 11.2508 15.4495 10.3537 15.3051C9.45654 15.1607 8.62779 14.7372 7.98527 14.0947C7.34276 13.4522 6.9192 12.6234 6.77484 11.7263C6.63048 10.8292 6.77268 9.90938 7.1812 9.09774C7.58972 8.2861 8.24377 7.62394 9.05031 7.20544C9.85685 6.78694 10.7748 6.63342 11.6736 6.7667C12.5905 6.90266 13.4393 7.32988 14.0947 7.98527C14.7501 8.64066 15.1773 9.48946 15.3132 10.4063Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.28,
    cy: 4.31988,
    r: 1.44,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2d0510688b25d232924c902ba626fbf4.svg";
export { ForwardRef as ReactComponent };